var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chevron_right_green_svg__clip0_1_4104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.708 14.707c.39.39 1.02.39 1.41 0l3.88-3.88 3.88 3.88a.996.996 0 101.41-1.41l-4.59-4.59a.996.996 0 00-1.41 0l-4.59 4.59c-.38.38-.38 1.02.01 1.41z",
    fill: "#58B847"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "chevron_right_green_svg__clip0_1_4104"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 12 12)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgChevronRightGreen;